<template>
<div>
    <div class="hidden bg-light-gray px-s20 py-s15 text-t14 uppercase m_580:grid m_580:grid-cols-wishlist-grid">
      <p class="text-center">Proizvod</p>
      <p class="pl-s40">Detalji</p>
      <div></div>
      <p class="text-right">Ukloni</p>
    </div>


    <div v-for="(item, index) in getItems" :key="index" class="grid gap-s10 items-center border-b border-light-gray p-s20 text-t14 m_580:gap-0 m_580:grid-cols-wishlist-grid-sm m_1200:grid-cols-wishlist-grid">
      <a :href="item.path">
        <img :src="item.image" :alt="item.title" class="max-w-s100 mx-auto m_580:max-w-full m_580:w-full" width="120" height="182" loading="lazy">
      </a>

      <div class="text-center m_580:text-left m_580:pl-s40 m_580:pr-s20">
        <p class="font-medium">{{ item.brend }}</p>
        <a :href="item.path">
          <p>{{ item.title }}</p>
        </a>
        <p>{{ item.code }}</p>
        <div class="mt-s10 text-t14">
          <p class="font-medium">Cena:</p>
          <p>{{ formatPrice(item.price) }} RSD</p>
        </div>
      </div>

      <a :href="item.path" class="max-w-fit grid items-center bg-black text-white py-s10 px-s20 m_580:py-s5 m_580:px-s5 mx-auto uppercase m_1000:hover:bg-light-gray m_1000:py-s10 m_1000:px-s20 m_1000:hover:text-black m_1000:transition-colors m_1000:duration-200">
        <span class="inline m_580:hidden m_1000:inline">Dodajte u korpu</span>
        <div class="hidden m_580:grid m_1000:hidden">
          <handbag-icon svgClassName="size-s20 m_650:size-s25"></handbag-icon>
        </div>
      </a>

      <button type="button" class="justify-self-center m_580:justify-self-end" @click="remove(index)">
        <remove-icon :index="index" svgClassName="size-s20 m_650:size-s25"></remove-icon>
      </button>

    </div>
</div>



</template>

<script>

import accounting from 'accounting';
import RemoveIcon from '../svg/RemoveIcon.vue';
import Handbag from '../svg/Handbag.vue';

export default {
  name: "Wishlist",

    components: {
    RemoveIcon,
    Handbag,
  },

  props: ['wishlistItems'],

  data: function () {
    return {
      getItems: this.wishlistItems,
    }
  },

  methods: {
    remove(index) {
      axios.post('/izbaci-iz-liste-zelja/' + index)
          .then(response => {

	          // Preview message
	          this.$toasted.global.toastSuccess({ message: response.data.message });

	          // Update vuex store, wishlist count
	          this.$store.dispatch('Cart/changeWishlistItemCount', response.data.wishlistItemsCount);

	          this.getItems = response.data.wishListItems;
          })
          .catch(e => {

          })
    },

    /**
     * Format price.
     *
     * @param value
     */
    formatPrice(value) {

      return accounting.formatMoney(value, '', 2, '.', ',')
    },
  }


}
</script>
